"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _MarketplaceProducts = _interopRequireDefault(require("../../components/MarketplaceProducts/MarketplaceProducts"));

var _useMarketplace2 = _interopRequireDefault(require("../../hooks/useMarketplace"));

var _gift = require("../../store/gift/gift.selector");

var _ProductPreview = _interopRequireDefault(require("../../components/ProductPreview/ProductPreview"));

var _marketplace = require("../../store/marketplace/marketplace.selector");

var _useGiftContext2 = require("../../hooks/useGiftContext");

var _commonData = require("../../../Shared/store/commonData");

var _useTrackMarketplace = require("./useTrackMarketplace");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var GiftMarketplaceProducts = function GiftMarketplaceProducts(_ref) {
  var giftId = _ref.giftId,
      onClose = _ref.onClose,
      onProductPreview = _ref.onProductPreview,
      countryId = _ref.countryId,
      onClosePreview = _ref.onClosePreview,
      previewedProductId = _ref.previewedProductId,
      onChooseProduct = _ref.onChooseProduct,
      isMarketplaceOpen = _ref.isMarketplaceOpen;

  var _useMarketplace = (0, _useMarketplace2.default)(giftId),
      setCategories = _useMarketplace.setCategories,
      categories = _useMarketplace.categories,
      setTypes = _useMarketplace.setTypes,
      types = _useMarketplace.types,
      filters = _useMarketplace.filters,
      pagination = _useMarketplace.pagination,
      showFilters = _useMarketplace.showFilters,
      setShowFilters = _useMarketplace.setShowFilters,
      search = _useMarketplace.search,
      setSearch = _useMarketplace.setSearch,
      selectedSortId = _useMarketplace.selectedSortId,
      loadProducts = _useMarketplace.loadProducts,
      products = _useMarketplace.products,
      isLoading = _useMarketplace.isLoading,
      filtersOptions = _useMarketplace.filtersOptions,
      onFilterProducts = _useMarketplace.onFilterProducts,
      onSortProducts = _useMarketplace.onSortProducts,
      onSearchProducts = _useMarketplace.onSearchProducts,
      sortItems = _useMarketplace.sortItems;

  var _useGiftContext = (0, _useGiftContext2.useGiftContext)(),
      _useGiftContext$user = _useGiftContext.user;

  _useGiftContext$user = _useGiftContext$user === void 0 ? {} : _useGiftContext$user;
  var _useGiftContext$user$ = _useGiftContext$user.orgId,
      orgId = _useGiftContext$user$ === void 0 ? null : _useGiftContext$user$,
      _useGiftContext$user$2 = _useGiftContext$user.orgName,
      orgName = _useGiftContext$user$2 === void 0 ? '' : _useGiftContext$user$2;
  var senderId = (0, _reactRedux.useSelector)(_gift.getGiftSenderId);
  var recipientId = (0, _reactRedux.useSelector)(_gift.getGiftRecipientId);
  var productInfo = (0, _reactRedux.useSelector)(_marketplace.getProduct);
  var isGiftLoading = (0, _reactRedux.useSelector)(_gift.getGiftIsLoading);
  var country = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return _commonData.CommonData.selectors.makeGetCountryById(countryId);
  }, [countryId]));

  var title = _react.default.useRef(null);

  var _useMemo = (0, _react.useMemo)(function () {
    return sortItems.find(function (item) {
      return item.id === selectedSortId;
    }) || {};
  }, [selectedSortId, sortItems]),
      _useMemo$sort = _useMemo.sort,
      sort = _useMemo$sort === void 0 ? null : _useMemo$sort;

  var trackMarketplaceData = {
    categories,
    types,
    countryId,
    senderId,
    recipientId,
    sort,
    search,
    orgId,
    orgName
  };
  (0, _useTrackMarketplace.useTrackMarketplaceVisitedEffect)(_objectSpread({
    isMarketplaceOpen
  }, trackMarketplaceData));
  (0, _useTrackMarketplace.useTrackMarketplaceSearchAppliedEffect)(_objectSpread({
    isLoading
  }, trackMarketplaceData));
  (0, _useTrackMarketplace.useTrackMarketplaceNextPageEffect)(trackMarketplaceData);
  (0, _useTrackMarketplace.useTrackMarketplaceProductViewedEffect)(trackMarketplaceData);
  var trackMarketplaceProductSelected = (0, _useTrackMarketplace.useTrackMarketplaceProductSelected)(trackMarketplaceData);
  (0, _react.useEffect)(function () {
    if (isMarketplaceOpen) {
      title.current.scrollIntoView(true);
    }
  }, [isMarketplaceOpen]);
  var handleChooseProduct = (0, _react.useCallback)(function () {
    trackMarketplaceProductSelected(previewedProductId);
    onChooseProduct();
  }, [onChooseProduct, previewedProductId, trackMarketplaceProductSelected]);
  var isEmpty = !isLoading && products.length === 0;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: !!previewedProductId,
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement(_ProductPreview.default, {
    product: productInfo,
    isLoading: isLoading,
    disabled: isGiftLoading,
    onClose: onClosePreview,
    onChoose: handleChooseProduct
  })), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: isMarketplaceOpen && !previewedProductId,
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement(_MarketplaceProducts.default, {
    goBackTitle: "Back to suggested options",
    setCategories: setCategories,
    categories: categories,
    setTypes: setTypes,
    types: types,
    filters: filters,
    titleRef: title,
    pagination: pagination,
    showFilters: showFilters,
    country: country,
    setShowFilters: setShowFilters,
    search: search,
    setSearch: setSearch,
    selectedSortId: selectedSortId,
    sortItems: sortItems,
    loadProducts: loadProducts,
    isEmpty: isEmpty,
    products: products,
    isLoading: isLoading,
    filtersOptions: filtersOptions,
    onClose: onClose,
    onFilterProducts: onFilterProducts,
    onSortProducts: onSortProducts,
    onSearchProducts: onSearchProducts,
    onProductPreview: onProductPreview
  })));
};

GiftMarketplaceProducts.propTypes = {
  giftId: _propTypes.default.number.isRequired,
  onClose: _propTypes.default.func.isRequired,
  onProductPreview: _propTypes.default.func.isRequired,
  onClosePreview: _propTypes.default.func.isRequired,
  onChooseProduct: _propTypes.default.func.isRequired,
  previewedProductId: _propTypes.default.number,
  countryId: _propTypes.default.number,
  isMarketplaceOpen: _propTypes.default.bool.isRequired
};
GiftMarketplaceProducts.defaultProps = {
  previewedProductId: null,
  countryId: null
};
var _default = GiftMarketplaceProducts;
exports.default = _default;